import { render, staticRenderFns } from "./StandardLayoutQuestion.vue?vue&type=template&id=35d1f91c&scoped=true&"
import script from "./StandardLayoutQuestion.vue?vue&type=script&lang=ts&"
export * from "./StandardLayoutQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./StandardLayoutQuestion.vue?vue&type=style&index=0&id=35d1f91c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d1f91c",
  null
  
)

export default component.exports